import { ButtonSecondary } from '@amelio/ui-library';

interface RetryButtonProps {
    label: string;
    onRetry: () => void;
    /** The status region the button follows, which takes the focus once the button is clicked. */
    statusRef: React.RefObject<HTMLDivElement | null>;
    isRetrying?: boolean;
    disabled: boolean;
    dataTestId: string;
}

/**
 * Hands the focus to its status region when clicked: the button leaves with the state it offered a way
 * out of, and the focus would otherwise fall back to the top of the page.
 */
export const RetryButton = ({
    label,
    onRetry,
    statusRef,
    isRetrying = false,
    disabled,
    dataTestId,
}: RetryButtonProps) => {
    const handleClick = () => {
        onRetry();
        statusRef.current?.focus();
    };

    return (
        <ButtonSecondary
            onClick={handleClick}
            loading={isRetrying}
            disabled={disabled}
            size={'sm'}
            fitContent
            className={'self-start'}
            dataTestId={dataTestId}
        >
            {label}
        </ButtonSecondary>
    );
};
